module.exports = __webpack_public_path__ + "static/media/hero-15.30e10285.jpg";